import React, { PureComponent } from 'react';
import chroma from 'chroma-js';
import TrackVisibility from 'react-on-screen';

import Ranking from '../GreenestRanking';
import Result from '../Result';
import ChoroplethMap from '~/core/scripts/widgets/ChoroplethMapWidget';
import Legend from '~/core/scripts/components/Legend';
import ListSearch from '~/core/scripts/components/ListSearch';
import { getCentroid } from '~/kits/general/scripts/utils';
import { sortByKey, isNumeric } from '~/core/scripts/utils';

class GreenestSection extends PureComponent {
  state = {
    selectedArea: null
  }

  constructor(props) {
    super();

    const { valueKey, colors } = props;
    const scale = chroma.scale(colors).domain([0, 5]);

    this.germanyData = props.data.find(d => d.AGS === '999');
    this.data = props.data
      .filter(d => isNumeric(d[valueKey]) && !['888', '999'].includes(d.AGS))
      .sort(sortByKey('rank', false));
    this.colorizer = properties => scale(properties[valueKey]);
    this.searchPresets = ['11000', '2000', '5113', '16051', '3101', '14521', '5315', '9464', '9162', '5958'].map(ags => props.data.find(d => d.AGS === ags));
  }

  onSelectArea(selectedArea) {
    if (selectedArea) {
      selectedArea.position = getCentroid(this.props.geojson, selectedArea.AGS);
    }

    this.setState({ selectedArea });
  }

  render() {
    const {
      geojson, valueKey, data, colors,
      dataInfo, stateGeojson, mapSource
    } = this.props;

    return (
      <TrackVisibility once partialVisibility>
        {({ isVisible }) => (
          <div className="greenest">
            <div className="greenest__headline">Die Grünsten der Grünen</div>
            <div className="greenest__subline">In elf von 401 Stadt- und Landkreisen sind alle fünf Merkmale überdurchschnittlich - in sieben davon sind es auch die Grünen</div>

            <div className="greenest__section top">
              <div className="greenest__ranking ranking">
                <Ranking
                  data={data}
                  valueKey={valueKey}
                  dataInfo={dataInfo}
                  germanyData={this.germanyData}
                />
                <div className="greenest__moreranking">
                  <span className="ranking__index">6</span> Havelland <em>(Brandenburg)</em>, <span className="ranking__index">7</span> Bremen, <span className="ranking__index">8</span> Bonn <em>(Nordrhein-Westfalen)</em>, <span className="ranking__index">9</span> Dahme-Spreewald <em>(Brandenburg)</em>, <span className="ranking__index">10</span> Weimar <em>(Thüringen)</em>, <span className="ranking__index">11</span> Konstanz <em>(Baden-Württemberg)</em>
                </div>
              </div>
              <div className="greenest__map">
                <ChoroplethMap
                  minZoom={4}
                  maxZoom={12}
                  choroplethData={geojson}
                  valueKey={valueKey}
                  colorizer={this.colorizer}
                  filterFunc={() => true}
                  isFiltered={false}
                  tooltipAbsLabel={null}
                  icon={null}
                  labelPreset="germany"
                  unit={null}
                  decimals={1}
                  data={data}
                  inverted
                  showMapToggleButton={false}
                  zoomControl=""
                  selectedArea={this.state.selectedArea}
                  stateGeojson={stateGeojson}
                  onClick={area => this.onSelectArea(area)}
                  hasTooltip={false}
                  isVisible={isVisible}
                  mapSource={mapSource}
                />
                <Legend
                  minLabel="Überdurchschnittliche Merkmale: 0"
                  maxLabel="5"
                  colors={colors}
                />
              </div>
            </div>

            <div className="greenest__section bot">
              <div className="greenest__search">
                <div className="greenest__search-title">Wie grün ist Ihre Gegend?</div>
                <ListSearch
                  placeholder="Namen des Kreises eingeben ..."
                  onSelect={selectedArea => this.onSelectArea(selectedArea)}
                  data={this.data}
                  fieldName="Kreis"
                  minChars={2}
                  searchPresetsFieldName="Kreis"
                  searchPresets={this.searchPresets}
                  searchPresetsTitle="Oder wählen Sie ein Beispiel:"
                />
              </div>
              <Result
                data={this.state.selectedArea}
                dataInfo={dataInfo}
                germanyData={this.germanyData}
              />
            </div>
          </div>
        )}
      </TrackVisibility>
    );
  }
}

export default GreenestSection;
